__turbopack_context__.v({
  "className": "jetbrains_mono_a20a6075-module__PjMJNW__className",
});
